import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

export interface UserDropdownItem {
  label: string;
  clickHandler: () => void;
}

interface AdminUserDropdownProps {
  isOpen: boolean;
  toggle: () => void;
  dropdownItems: UserDropdownItem[];
}

export const AdminUserDropdown = ({ isOpen, toggle, dropdownItems }: AdminUserDropdownProps) => {
  return (
    <Dropdown isOpen={isOpen} toggle={toggle}>
      <DropdownToggle color='transparent' outline className='px-2'>
        <i className='fas fa-bars' />
      </DropdownToggle>
      <DropdownMenu>
        {dropdownItems.map((dropdownItem) => (
          <DropdownItem key={dropdownItem.label} onClick={dropdownItem.clickHandler}>{dropdownItem.label}</DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
